import React, {useEffect, useCallback, useState} from "react";
import {getBetterCryptoSuggestion, getTop7DayPerformerGainerLooserAPI} from "../../../../apihelper/profile";
import {Skeleton, useMediaQuery, Button} from "@mui/material";
import json2mq from "json2mq";
import {useNavigate} from "react-router-dom";
import TableHook from "../../../account/profile/tables/TableHook";
import TableCardHook from "../../../account/profile/tables/TableCardHook";
import {VolunteerActivismOutlined} from "@mui/icons-material";
import {getPortfolioData} from "../../../../apihelper/portfolio";
import Box from "@mui/material/Box";
import AddToPortfolio from '../../../AddToPortfolio';


export const OtherRecommendation = (props = {}) => {
    const {cryptoList, portfolioId} = props;
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [loading, setLoading] = useState(false);
    const [my7DaysPortfolio, setMy7DaysPortfolio] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    // const [tableData, setTableData] = useState([]);
    const navigate = useNavigate();
    const [selectedCrypto, setSelectedCrypto] = useState();
    const [portfolio_id, setPortfolio_id] = useState();
    useEffect(() => {
        setPortfolio_id(portfolioId);
    }, [portfolioId]);
    const [sortType, setSortType] = useState("fd_asc");
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [isPredictionDataLoaded, setIsPredictionDataLoaded] = useState(false);

    const fetchPortfolioCrypto = useCallback(() => {
        if (!userData || !portfolio_id) {
            return;
        }
        setLoading(true);
        const data = {
            portfolio_type_id: portfolio_id,
            user_id: userData.user_id,
            Token: userData.token,
        };
        console.log("Calling api");
        getPortfolioData(data)
        .then((res) => {
            const slugArray = res.data.map((item) => item.slug);
            console.log("slugArray", res.data);
            setSelectedCrypto(slugArray);
        })
        .catch((error) => {
            console.error("Fetch data error:", error);
            setLoading(false);
        });
    }, [portfolio_id]);

    useEffect(() => {
        if (userData || portfolio_id) {
            fetchPortfolioCrypto();
        }
    }, [fetchPortfolioCrypto]);

    const fetchData = useCallback(() => {
        console.log("selectedCrypto", selectedCrypto);
        if (!portfolio_id) {
            return;
        }
        setLoading(true);
        const limit = 1;
        getBetterCryptoSuggestion(selectedCrypto, portfolio_id, limit, userData)
        .then((res) => {
            setMy7DaysPortfolio(res);
            setLoading(false);
        })
        .catch((error) => {
            console.error("Fetch data error:", error);
            setLoading(false);
        });
    }, [portfolio_id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    

  const fetchCryptoData = async () => {
  setLoading(true);
  try {
    const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/smartMoneyPicks");
    const result = await response.json();

    // Load excluded symbols from localStorage (these are from recommendations)
    const storageKey = `cw_recommendation_symbols_${portfolioId}`;
    const stored = localStorage.getItem(storageKey);
    const excludedSymbols = stored ? JSON.parse(stored) : [];

    // Filter smart picks that are NOT already in recommendations
    const filtered = result.filter(item => !excludedSymbols.includes(item.crypto));

    // Take only first 2 that are unique
    const limitedData = filtered.slice(0, 2);
    setData(limitedData);
    console.log("Filtered Smart Money Picks:", limitedData);
  } catch (err) {
    setError("An error occurred while fetching data.");
  } finally {
    setLoading(false);
  }
};





    useEffect(() => {
        fetchCryptoData(); // Fetch data when component mounts
    }, [portfolio_id]);
    const formatToNonZero = (number) => {
        number = parseFloat(number);

        if (number >= 1) {
            return number.toFixed(2);
        } else if (number >= 0.1) {
            return number.toFixed(1);
        } else if (number >= 0.01) {
            return number.toFixed(4);
        } else if (number >= 0.001) {
            return number.toFixed(5);
        } else if (number >= 0.0001) {
            return number.toFixed(6);
        } else if (number >= 0.00001) {
            return number.toFixed(7);
        } else if (number >= 0.000001) {
            return number.toFixed(8);
        } else if (number >= 0.0000001) {
            return number.toFixed(9);
        } else if (number >= 0.00000001) {
            return number.toFixed(10);
        } else if (number >= 0.000000001) {
            return number.toFixed(11);
        }
        return number.toFixed(1);
    };
    

    const tabData = data?.map((portfolio, index) => [
  // Column 1 - Crypto
  <div style={{ display: "flex", gap: "12px", alignItems: "center" }} key={`crypto-${index}`}>
    <div
      style={{
        padding: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontWeight: "bold",
        fontSize: "12px",
        color: "#333",
        borderRadius: "20px",
        width: "205px",
        height: "62px",
        background: "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          width={38.77}
          height={37}
          style={{
            borderRadius: "19px",
            border: "2px solid black",
            marginRight: "10px",
            display: "block",
          }}
          src={portfolio.logo}
          alt={portfolio.crypto}
        />
        <div
          className="btcParent"
          style={{
            fontWeight: "700",
            fontSize: "20px",
            lineHeight: "1",
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          {portfolio.crypto}
        </div>
      </div>
    </div>
  </div>,

  <span>{portfolio.price}</span>,
  <span>{portfolio.Thirtyd_change}</span>,
  <span>{portfolio.Year_change}</span>,
  <span>{portfolio.recorded_on}</span>,
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }}
  >
    <span
      style={{
        backgroundColor:
          portfolio.Norm_grade === "Outperformer" || portfolio.Norm_grade === "Emerging Outperformer"
            ? "#199F5F"
            : portfolio.Norm_grade === "Moderate Performer"
            ? "#D4AF37"
            : portfolio.Norm_grade === "Underperformer"
            ? "#FF4141"
            : "gray",
        color: "white",
        padding: "5px 12px",
        borderRadius: "15px",
        fontSize: "12px",
        fontWeight: "bold",
        minWidth: "140px",
        textAlign: "center",
        marginRight:"-3.5vw"
      }}
    >
      {portfolio.Norm_grade === "Emerging Outperformer" ? "Outperformer" : portfolio.Norm_grade}
    </span>
  </div>,

  portfolio.crypto && (
      <AddToPortfolio
        slugName={portfolio.crypto}
        triggerElement={
          <button
            className={`rounded-pill btn-3`}
          >
        
              <img
                style={{width:"27px", height:"27px"}}
                src="../images/icons/add_icon.svg"
                alt="Add"
              />
    
          </button>
        }
      />
    )

]);

const tableHeader = [
    { label: "Crypto", key: "crypto", sorting: true },
    { label: "Price", key: "seven_day", sorting: true },
    { label: "Last 30 Days", key: "crypto", sorting: true },
    { label: "Last 1 Year", key: "seven_day", sorting: true },
    { label: "Date", key: "date", sorting: false },
    { label: "Grade", key: "grade", sorting: false },
    { label: " ", key: "add", sorting: false }
];
  return (
        <div className="section-2">
            <TableHook header={tableHeader} tableData={tabData} loading={loading} />

            {/* for mobile */}
            {data?.map((portfolio, index) => (
               <TableCardHook
                                   key={index}
                                   header={{
                   name: portfolio.crypto,
                   icon: `${portfolio["logo"]}`,
                   info_btn: "Memecoin",
            
                 }}
                                   body={[
                                       {key: "Price", value: `$${portfolio["price"]}`},
               
                                       {key: "Last 30 Days", value: `${portfolio["Thirtyd_change"]}`},
                                       {key: "Last 1 Year", value: `${portfolio["Year_change"]}`},
                                       {key: "Date", value: `${portfolio["recorded_on"]}`},
                                       {
                                           key: "Grade",
                                           value: (
                                               <span
      style={{
        backgroundColor:
          portfolio.Norm_grade === "Outperformer" || portfolio.Norm_grade === "Emerging Outperformer"
            ? "#199F5F"
            : portfolio.Norm_grade === "Moderate Performer"
            ? "#D4AF37"
            : portfolio.Norm_grade === "Underperformer"
            ? "#FF4141"
            : "gray",
        color: "white",
        padding: "5px 12px",
        borderRadius: "15px",
        fontSize: "12px",
        fontWeight: "bold",
        minWidth: "140px",
        textAlign: "center",
        marginRight:"-2.5vw"
      }}
    >
      {portfolio.Norm_grade === "Emerging Outperformer" ? "Outperformer" : portfolio.Norm_grade}
    </span>
                                           ),
                                       },
                                   ]}
                                   footer={[
  {
    label: (
      portfolio.crypto && (
        <AddToPortfolio
          slugName={portfolio.crypto}
          triggerElement={
            <button className="rounded-pill btn-3" style={{fontSize:"bold"}}>
              Add More
            </button>
          }
        />
      )
    ),
  },
  {
    label: (
      portfolio.crypto && (
        <AddToPortfolio
          slugName={portfolio.crypto}
          triggerElement={
            <button className="rounded-pill btn-3" style={{fontSize:"bold"}}>
              Remove
            </button>
          }
        />
      )
    ),
  },
]}

                               />
            ))}
            <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff', // optional background
        marginTop:"4%"
      }}
    >
      <button
        onClick={() => navigate('/crypto-screener/smart-money-picks')}
        className="edit-btn"
        style={{fontWeight:"bold"}}
      >
        See More Smart Money Picks
      </button>
    </div>
            {loading &&
                Array.from({length: 3}).map((_, index) => (
                    <TableCardHook
                        key={index}
                        header={{
                            name: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            icon: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} width={40} />,
                        }}
                        body={[
                            {key: "Price", value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />},
                            {
                                key: "Last 7 Days",
                                value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            },
                            {
                                key: "Last 30 Days",
                                value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            },
                        ]}
                        footer={[{label: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />}]}
                        loading={loading}
                    />
                ))}

            
        </div>
    );
};
